import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { API_BASE } from '../config'

const C = {
  g900:'#0D2218', g800:'#1A3A28', g700:'#235233', g600:'#2D6B42',
  g400:'#5AAE73', g50:'#F2FAF5', white:'#FFFFFF',
  muted:'#5A7065', border:'#C8DDD2', error:'#C0392B',
}

export default function PharmacyRegister() {
  const navigate = useNavigate()
  const [form, setForm] = useState({ name:'', ownerName:'', email:'', phone:'', address:'', licenseNumber:'' })
  const [errors, setErrors] = useState({})
  const [submitting, setSubmitting] = useState(false)
  const [done, setDone] = useState(false)
  const [msg, setMsg] = useState('')

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))

  const validate = () => {
    const e = {}
    if (!form.name.trim())  e.name  = 'Pharmacy name is required'
    if (!form.phone.trim()) e.phone = 'Phone number is required'
    if (!form.address.trim()) e.address = 'Address is required'
    setErrors(e)
    return Object.keys(e).length === 0
  }

  const submit = async (e) => {
    e.preventDefault()
    if (!validate()) return
    setSubmitting(true)
    try {
      const res = await fetch(`${API_BASE}/api/pharmacy/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      })
      const data = await res.json()
      if (res.ok) setDone(true)
      else setMsg(data.message || 'Registration failed.')
    } catch {
      setMsg('Error connecting to server. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  const inp = (key, label, type='text', required=false) => (
    <div key={key}>
      <label style={{ fontSize: '.78rem', fontWeight: 600, color: C.muted, display: 'block', marginBottom: '.3rem' }}>
        {label} {required && <span style={{ color: C.error }}>*</span>}
      </label>
      <input type={type} value={form[key]} onChange={e => set(key, e.target.value)}
        style={{ width: '100%', padding: '.7rem 1rem', border: `1.5px solid ${errors[key] ? C.error : C.border}`, borderRadius: 9, fontSize: '.875rem', outline: 'none', fontFamily: "'DM Sans',sans-serif", boxSizing: 'border-box' }} />
      {errors[key] && <div style={{ fontSize: '.72rem', color: C.error, marginTop: '.2rem' }}>{errors[key]}</div>}
    </div>
  )

  if (done) return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: C.g50, padding: '2rem' }}>
      <div style={{ background: 'white', borderRadius: 20, padding: '2.5rem', width: '100%', maxWidth: 420, boxShadow: '0 4px 24px rgba(13,34,24,.08)', border: `1px solid ${C.border}`, textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
        <h2 style={{ fontFamily: "'DM Serif Display',serif", fontSize: '1.5rem', color: C.g900, marginBottom: '.75rem' }}>Application Submitted!</h2>
        <p style={{ fontSize: '.875rem', color: C.muted, lineHeight: 1.6, marginBottom: '1.5rem' }}>
          Thank you for applying to partner with Revive Skin & Hair Clinic.<br />
          Our team will review your application and contact you within 24 hours.
        </p>
        <button onClick={() => navigate('/')} style={{ padding: '.8rem 2rem', borderRadius: 10, background: C.g700, color: 'white', border: 'none', fontSize: '.875rem', fontWeight: 600, cursor: 'pointer', fontFamily: "'DM Sans',sans-serif" }}>
          Back to Home
        </button>
      </div>
    </div>
  )

  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: C.g50, padding: '2rem' }}>
      <div style={{ background: 'white', borderRadius: 20, padding: '2.5rem', width: '100%', maxWidth: 480, boxShadow: '0 4px 24px rgba(13,34,24,.08)', border: `1px solid ${C.border}` }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: '1.75rem' }}>
          <span style={{ fontSize: '1.8rem' }}>💊</span>
          <div>
            <div style={{ fontFamily: "'DM Serif Display',serif", fontSize: '1.4rem', color: C.g900 }}>Partner Pharmacy Registration</div>
            <div style={{ fontSize: '.75rem', color: C.muted }}>Join Revive's network of partner pharmacies</div>
          </div>
        </div>

        <div style={{ background: C.g50, border: `1px solid ${C.border}`, borderRadius: 10, padding: '.75rem 1rem', marginBottom: '1.25rem', fontSize: '.78rem', color: C.muted, lineHeight: 1.6 }}>
          Partner pharmacies receive prescription orders from Revive patients directly via WhatsApp and deliver medicines to their doorstep.
        </div>

        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: '.85rem' }}>
          {inp('name',          'Pharmacy Name',          'text', true)}
          {inp('ownerName',     'Owner / Manager Name',   'text', false)}
          {inp('phone',         'WhatsApp Phone Number',  'tel',  true)}
          {inp('email',         'Email Address',          'email',false)}
          {inp('address',       'Full Address',           'text', true)}
          {inp('licenseNumber', 'Drug License Number',    'text', false)}

          {msg && <div style={{ fontSize: '.82rem', color: C.error, padding: '.75rem', background: '#FEF2F2', borderRadius: 8 }}>{msg}</div>}

          <button type="submit" disabled={submitting}
            style={{ padding: '.9rem', borderRadius: 10, background: submitting ? C.g400 : C.g700, color: 'white', border: 'none', fontSize: '.9rem', fontWeight: 600, cursor: submitting ? 'not-allowed' : 'pointer', fontFamily: "'DM Sans',sans-serif", marginTop: '.25rem' }}>
            {submitting ? 'Submitting…' : 'Submit Application'}
          </button>
          <button type="button" onClick={() => navigate(-1)}
            style={{ padding: '.7rem', borderRadius: 9, background: 'none', color: C.muted, border: `1px solid ${C.border}`, fontSize: '.82rem', cursor: 'pointer', fontFamily: "'DM Sans',sans-serif" }}>
            ← Go Back
          </button>
        </form>
      </div>
    </div>
  )
}
